import { Box } from "@mui/material";
import { DeliveryEarnings } from "../Components/delivery_earnings";
import { Sidebar } from "../Components/dp-sidebar";
import { Header } from "../Components/dp-header";
import { useDispatch, useSelector } from "react-redux";
import { OrederManagement } from "../Components/order_management/order_lists_dp";
import { useEffect } from "react";
import { updateFirst_name, updateId, updateLast_name } from "../Redux/user";
import { jwtDecode } from "jwt-decode";
import dayjs from "dayjs";
import { useState } from "react";
import { updateDeliveryPartners, updateselectedDeliveryPartner } from "../Redux/orders";
import CustomAxios from "../utils/CustomAxios";

export function DPHome() {
    const page = useSelector(state => state.page.dp_pageName)
    console.log(page)
    const authToken = localStorage.getItem('authtoken')
    const id = localStorage.getItem('id');
    const decodedToken = jwtDecode(authToken);
    const actorders = useSelector(state => state.orders.orders);
    const [deliveryPartners,setDeliveryPartners] = useState([])
    const partners = useSelector(state => state.orders.deliveryPartners);
    const [orders,setOrders] = useState([])
    const [deliverypartner, setDeliverypartner]= useState()
    const mobileno = decodedToken.mobileno;
    const first_name = localStorage.getItem('first_name');
    const last_name = localStorage.getItem('last_name');
    const today = dayjs()
    console.log(id)

    useEffect(()=>{
        const orders = actorders.filter(order=>{if (order.delivery_partner_id==deliverypartner?.id){
            return order
        }})
        setOrders(orders)

    },[actorders])

  // const GetFetchedOrders = useFetchOrders()
  // const GetOrders = useGetOrders()
  const dispatch = useDispatch()
    useEffect(()=>{
        dispatch(updateFirst_name(first_name))
        dispatch(updateLast_name(last_name));
        dispatch(updateId(id));

  },[authToken])
  useEffect(()=>{
    setDeliveryPartners(partners)
},[partners])

const getUsers = async () => {
    const users = await CustomAxios.get(`get_users/`, {
    }).then(res => {
        console.log("--------->",res.data)
        let deliveryPartners = res.data.users.filter((user)=>
            user.role ==='delivery' && user.mobileno==mobileno
        )
        console.log(deliveryPartners)
        dispatch(updateDeliveryPartners(deliveryPartners))
    })

}
useEffect(() => {
    getUsers()
}, [])
  // Django Channels partner WS (REACT_APP_SOCKET_URL) removed — dead code.
  // Admin realtime is Azure Web PubSub only; partner page has no PubSub listener yet.

    useEffect(()=>{
        const delivery_partner = deliveryPartners.find((partner)=>partner.mobileno === mobileno)
        console.log("41 -------------------------------- deliverypartner",mobileno,deliverypartner)
        setDeliverypartner(delivery_partner)
        dispatch(updateselectedDeliveryPartner(delivery_partner))

    },[deliveryPartners])
      console.log(deliveryPartners,mobileno)
    return (<Box sx={{ width: "100%", height: "100vh", backgroundColor: 'background.default' }}>
        <Header />
        <Box sx={{ display: "flex",height:'calc( 100vh - 72px)',overflowY:'auto' }}>
            <Sidebar/>
            <Box sx={{width:"100%" }}>
                {/* {page === "dashboard" && <Dashboard />}

                {page === "product_details" && <ProductDetails />}
                {page === "campaign" && <Campaign />}
                {page === "inventory" && <Inventory />} */}

                {page === "order_management" && <OrederManagement />}
                {page === "dp-earnings" && <DeliveryEarnings />}
                {/* {page === "user_management" && <UserManagement />} */}
            </Box>

        </Box>
    </Box>)
}